<template>
  <div :class="{eccenter: center}">
    <small-button :large="!small" v-on:click="showQuote">{{ $nippets.portfolio.email }}</small-button>
    <call-button :right="right" :name="artist.formatted_name">{{ $nippets.portfolio.call }}</call-button>
  </div>
</template>

<script>
import CallButton from '@/components/buttons/CallButton.vue'
export default {
  components: {
    CallButton
  },
  props: {
    right: Boolean,
    artist: Object,
    center: Boolean,
    small: Boolean
  },
  methods: {
    showQuote: async function () {
      if(!this.artist) {
        this.$store.commit('setShowQuote', 'true')
      }
      else {
        this.$store.commit('setShowQuote', { show: true, artist: this.artist })
        this.$k.sendGaEvent('ArtistPortfolio', 'EmailClick', this.artist.formatted_name)
      }
      
    }
  }
}
</script>

<style>
.eccenter{
  text-align:center;
}
</style>
